export default __webpack_public_path__ + "static/homepage-2-beb222c21dfec4454818612b2825e0f0.png";